/* 2025/9/7 コレクションカスタム — collection-846.js（最小版・選択保持確定）
   2026/9/14 修正：フィルタ・ソート変更時は必ず1ページ目に戻す（page パラメータを除去）
                  存在しないページ番号を開いた場合は1ページ目へ自動復帰 */
if (!window.__ct846_inited) {
  window.__ct846_inited = true;

  document.addEventListener('DOMContentLoaded', () => {
    // JPY=1 / 非JPY=100 をラッパーから取得（URLに入れる倍率）
    const wrap = document.querySelector('.ct-846__container');
    const MINOR = parseInt(wrap?.dataset?.minorUnit || '1', 10); // ← JPYなら1

    // 初回：sort_by 無し→新着順
    const u0 = new URL(location.href);
    if ((!window.Shopify || !Shopify.designMode) && !u0.searchParams.has('sort_by')) {
      u0.searchParams.set('sort_by', 'created-descending');
      return location.replace(u0.toString());
    }

    // 範囲外ページ対策：Liquid側が .ct-846__out-of-range を出力していたら1ページ目へ
    if (document.querySelector('.ct-846__out-of-range') && (!window.Shopify || !Shopify.designMode)) {
      const u1 = new URL(location.href);
      if (u1.searchParams.has('page')) {
        u1.searchParams.delete('page');
        return location.replace(u1.toString());
      }
    }

    // 共通：URLを組み替えて遷移。フィルタ／ソートを変えたら必ず1ページ目に戻す
    const go = (mutate) => {
      const url = new URL(location.href);
      const p = url.searchParams;
      mutate(p);
      p.delete('page'); // ← ここが今回のバグ修正の要
      url.search = p.toString();
      location.assign(url.toString());
    };

    // Brand（vendor）
    document.querySelectorAll('select[name="__vendor_select"]').forEach(sel => {
      const key = sel.getAttribute('data-param') || 'filter.p.vendor';
      sel.addEventListener('change', e => {
        const v = e.target.value;
        go(p => { p.delete(key); if (v && v !== '__clear__') p.set(key, v); });
      });
    });

    // SIZE（いじらない）
    document.querySelectorAll('select[name="__size_select"]').forEach(sel => {
      const key = sel.getAttribute('data-param') || 'filter.v.option.size';
      sel.addEventListener('change', e => {
        const v = e.target.value;
        go(p => { p.delete(key); if (v && v !== '__clear__') p.set(key, v); });
      });
    });

    // Price（"5000-10000" / "50000-" / "__clear__"）だけを URL に反映
    document.querySelectorAll('select[name="__price_bucket_fixed"]').forEach(sel => {
      sel.addEventListener('change', e => {
        const v = e.target.value;
        go(p => {
          // 既存の価格キーは完全に掃除
          p.delete('filter.v.price.gte');
          p.delete('filter.v.price.lte');

          if (!v || v === '__clear__') return; // 価格条件なし

          const [minStr, maxStr] = v.split('-');
          const toMinor = (n) => (isNaN(n) ? '' : String(parseInt(n, 10) * MINOR));
          if (minStr && minStr !== '') p.set('filter.v.price.gte', toMinor(minStr));
          if (typeof maxStr !== 'undefined' && maxStr !== '') p.set('filter.v.price.lte', toMinor(maxStr));
        });
      });
    });

    // --- Price: 現在のURL値をセレクター表示に反映（保持が崩れるテーマJS対策） ---
    (function syncPriceSelectFromURL(){
      const priceSel = document.querySelector('select[name="__price_bucket_fixed"]');
      if (!priceSel) return;

      const url = new URL(location.href);
      const p = url.searchParams;
      const gte = p.get('filter.v.price.gte'); // URLの最小単位（JPY=×1 / 非JPY=×100）
      const lte = p.get('filter.v.price.lte');

      const fromMinor = (s) => {
        if (!s || isNaN(parseInt(s, 10))) return '';
        // 例: JPYなら 5000 -> 5000、USD系なら 500000 -> 5000 に戻す
        return String(Math.round(parseInt(s, 10) / MINOR));
      };

      const min = fromMinor(gte);
      const max = fromMinor(lte);

      // セレクターの value 文字列に合わせて組み立て
      let bucket = '__clear__';
      if (min && max) bucket = `${min}-${max}`;
      else if (min && !max) bucket = `${min}-`;   // 例: 50000-（以上）

      // その value が存在するなら選択。なければ「価格を指定しない」に戻す
      if ([...priceSel.options].some(o => o.value === bucket)) {
        priceSel.value = bucket;
      } else {
        priceSel.value = '__clear__';
      }
    })();

    // 在庫ありのみ
    const inStock = document.querySelector('input[name="__in_stock_only"]');
    if (inStock) {
      const key = inStock.getAttribute('data-param') || 'filter.v.availability';
      inStock.addEventListener('change', e => {
        go(p => { p.delete(key); if (e.target.checked) p.set(key, '1'); });
      });
    }

    // Sort
    const sortSel = document.getElementById('SortBy-846');
    if (sortSel) sortSel.addEventListener('change', e => {
      const v = e.target.value;
      go(p => { p.delete('sort_by'); if (v && v !== '__clear__') p.set('sort_by', v); });
    });

    // ページ移動時：商品グリッドの先頭までスムーズにスクロール（別ページから page 付きで来た場合）
    const u2 = new URL(location.href);
    if (u2.searchParams.has('page') && u2.searchParams.get('page') !== '1') {
      const grid = document.querySelector('.ct-846__grid');
      if (grid && document.referrer && document.referrer.split('?')[0] === location.href.split('?')[0]) {
        grid.scrollIntoView({ block: 'start' });
      }
    }
  });
}
